var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdv3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 60,
    viewBox: "0 0 97 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_696_100799)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.100586 28.1669C0.100586 26.7112 1.06708 25.2554 3.00008 24.1447L41.5001 2.02223C45.366 -0.199162 51.6341 -0.199202 55.5001 2.02223L94 24.1447C95.933 25.2554 96.899 26.7111 96.899 28.1669V32.1892C96.899 30.7334 95.933 29.2776 94 28.1669L55.5001 6.04449C51.6341 3.82306 45.366 3.8231 41.5001 6.04449L3.00008 28.1669C1.06708 29.2776 0.100586 30.7334 0.100586 32.1892V28.1669Z",
    fill: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_iii_696_100799)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.899 28.1671C96.899 29.6229 95.933 31.0787 94 32.1894L55.5001 54.3118C51.6341 56.5333 45.366 56.5332 41.5001 54.3118L3.00008 32.1894C1.06708 31.0787 0.100586 29.6229 0.100586 28.1671V32.1894C0.100586 33.6451 1.06708 35.1009 3.00008 36.2116L41.5001 58.3341C45.366 60.5555 51.6341 60.5555 55.5001 58.3341L94 36.2116C95.933 35.1009 96.899 33.6452 96.899 32.1894V28.1671Z",
    fill: "url(#paint0_linear_696_100799)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M41.6671 2.12778L3.18368 24.2407C-0.590133 26.4091 -0.590133 29.9249 3.18368 32.0934L41.6671 54.2063C45.4409 56.3747 51.5595 56.3747 55.3333 54.2063L93.8167 32.0934C97.5905 29.9249 97.5905 26.4091 93.8167 24.2407L55.3333 2.12778C51.5595 -0.040689 45.4409 -0.0406878 41.6671 2.12778Z",
    fill: "white",
    stroke: "#EBF4FF",
    strokeWidth: 0.404145
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.9337 34.797C54.9503 38.8097 43.628 38.8097 36.6446 34.797C29.6612 30.7843 29.6612 24.2784 36.6446 20.2657C43.628 16.2529 54.9503 16.2529 61.9337 20.2657C68.9171 24.2784 68.9171 30.7843 61.9337 34.797ZM39.1735 21.7188C33.5868 24.929 33.5868 30.1337 39.1735 33.3439C44.7602 36.5541 53.818 36.5541 59.4048 33.3439C64.9915 30.1337 64.9915 24.929 59.4048 21.7188C53.818 18.5086 44.7602 18.5086 39.1735 21.7188Z",
    fill: "#3399CC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.5754 25.5005C40.9944 25.1666 40.9989 24.6227 41.5855 24.2856L43.9753 22.9124C46.1751 21.6484 49.7246 21.6387 51.9034 22.8906C54.0823 24.1426 54.0653 26.1822 51.8655 27.4462L50.5378 28.2091L51.5899 28.8136L53.7141 27.593C54.3008 27.2559 55.2473 27.2533 55.8283 27.5872C56.4093 27.921 56.4048 28.4649 55.8182 28.802L53.6939 30.0226L54.7459 30.6271C55.327 30.961 55.3224 31.5049 54.7358 31.8419C54.1492 32.179 53.2027 32.1816 52.6217 31.8477L51.5696 31.2432L49.4453 32.4639C48.8587 32.8009 47.9122 32.8035 47.3312 32.4697C46.7502 32.1358 46.7547 31.5919 47.3413 31.2549L49.4656 30.0342L48.4135 29.4297L46.2893 30.6504C45.7027 30.9874 44.7561 30.99 44.1751 30.6562C43.5941 30.3223 43.5986 29.7784 44.1852 29.4414L46.3095 28.2207L41.5754 25.5005ZM48.4338 27.0001L49.7615 26.2372C50.788 25.6473 50.7959 24.6955 49.7792 24.1113C48.7624 23.527 47.1059 23.5316 46.0794 24.1214L44.7517 24.8843L48.4338 27.0001Z",
    fill: "#3399CC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_iii_696_100799",
    x: 0.100586,
    y: 28.1671,
    width: 96.7983,
    height: 34.2579,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.21244
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.0627451 0 0 0 0 0.239216 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_696_100799"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.42487
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.42487
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.0627451 0 0 0 0 0.239216 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_696_100799",
    result: "effect2_innerShadow_696_100799"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.42487
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.04145
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.0627451 0 0 0 0 0.239216 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_696_100799",
    result: "effect3_innerShadow_696_100799"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_696_100799",
    x1: 0.100586,
    y1: 28.1671,
    x2: 24.9289,
    y2: 88.7835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3399CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#AED6EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3399CC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_696_100799"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 97,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdv3);
export default __webpack_public_path__ + "static/media/adv-3.d00e8a5f3d9953774b4f8a92e98d3330.svg";
export { ForwardRef as ReactComponent };